module.exports = __webpack_public_path__ + "img/UT0412.8050aa10.png";